/**
 * Boolean型の安全な変換ユーティリティ
 * MySQL → PostgreSQL 移行対応
 */

/**
 * 値をBoolean型に安全に変換
 * @param {any} value - 変換する値
 * @returns {boolean} - Boolean値
 */
export const ensureBoolean = (value) => {
  if (value === true || value === 1 || value === "true") return true;
  if (value === false || value === 0 || value === "false") return false;
  return Boolean(value);
};

/**
 * API送信用のBoolean値に変換
 * @param {any} value - 変換する値
 * @returns {boolean} - API送信用Boolean値
 */
export const ensureBooleanForAPI = (value) => {
  return ensureBoolean(value);
};